import styled from '@emotion/styled'

export const Enrollment = styled.div`
  font-family: 'Muli', sans-serif;
  iframe[src*='Payment'] {
    height: 490px;
  }

  .div-enroll {
    margin-top: 0;
  }
`
